var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"jds-py-1 jds-px-4 jds-whitespace-nowrap jds-text-right"},[_c('jds-money',{attrs:{"amount":_vm.amount,"currency":_vm.currency}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }